import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-analytics-identity',
  templateUrl: './help-google-analytics-identity.component.html'
})
export class HelpGoogleAnalyticsIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
